import cx from "classnames";

import {
  ArrowsLeftRight,
  CalendarArrow,
  CheckList,
  Cross,
  Edit,
  ExclamationMarkCircle,
  Eye,
  EyeArrowCircle,
  File,
  FlagRacing,
  Flash,
  Gear,
  Hourglass,
  Pickaxe,
  Play,
  Policy,
  Skip,
  StopCircle,
  ThumbDown,
  ThumbUp,
  Tick,
  Trash,
} from "components/icons/generated";
import Badge from "ds/components/Badge";
import { BadgeVariants } from "ds/components/Badge/types";
import { IconComponent } from "types/Icon";

import { RunHistoryEntryType } from "../../types";
import styles from "./styles.module.css";

type RunHistoryEntryConfig = {
  icon: IconComponent;
  variant?: BadgeVariants;
};

/** @public (Knip ignored - used in the file and exported for stories) */
export const STATES: Record<RunHistoryEntryType, RunHistoryEntryConfig> = {
  [RunHistoryEntryType.Comment]: { icon: File },
  [RunHistoryEntryType.Queued]: { icon: Hourglass, variant: "gray" },
  [RunHistoryEntryType.Ready]: { icon: FlagRacing, variant: "gray" },
  [RunHistoryEntryType.Discarded]: { icon: ThumbDown, variant: "red" },
  [RunHistoryEntryType.Preparing]: { icon: CheckList, variant: "blue" },
  [RunHistoryEntryType.Initializing]: { icon: Gear, variant: "blue" },
  [RunHistoryEntryType.Planning]: { icon: Edit, variant: "blue" },
  [RunHistoryEntryType.Unconfirmed]: { icon: Eye, variant: "yellow" },
  [RunHistoryEntryType.ReplanRequested]: { icon: CalendarArrow, variant: "gray" },
  [RunHistoryEntryType.Failed]: { icon: ExclamationMarkCircle, variant: "red" },
  [RunHistoryEntryType.Confirmed]: { icon: ThumbUp, variant: "gray" },
  [RunHistoryEntryType.Applying]: { icon: Play, variant: "blue" },
  [RunHistoryEntryType.Finished]: { icon: Tick, variant: "green" },
  [RunHistoryEntryType.Canceled]: { icon: Cross, variant: "red" },
  [RunHistoryEntryType.Stopped]: { icon: StopCircle, variant: "red" },
  [RunHistoryEntryType.Performing]: { icon: Flash, variant: "blue" },
  [RunHistoryEntryType.Skipped]: { icon: Skip, variant: "gray" },
  [RunHistoryEntryType.Destroying]: { icon: Trash, variant: "blue" },
  [RunHistoryEntryType.PendingReview]: { icon: EyeArrowCircle, variant: "yellow" },
  [RunHistoryEntryType.WorkerPool]: { icon: Pickaxe },
  [RunHistoryEntryType.Dependencies]: { icon: ArrowsLeftRight },
  [RunHistoryEntryType.TriggeredRuns]: { icon: ArrowsLeftRight },
  [RunHistoryEntryType.ApprovalPolicies]: { icon: Policy },
  [RunHistoryEntryType.PlanPolicies]: { icon: Policy },
  [RunHistoryEntryType.TriggerPolicies]: { icon: Policy },
  [RunHistoryEntryType.InitializationPolicies]: { icon: Policy },
  [RunHistoryEntryType.NotificationPolicies]: { icon: Policy },
  [RunHistoryEntryType.PushPolicies]: { icon: Policy },
};

type HistoryEntryStateProps = {
  type: RunHistoryEntryType;
  className?: string;
};

const HistoryEntryState = ({ type, className }: HistoryEntryStateProps) => {
  if (!STATES[type]) {
    return null;
  }

  const elementClass = cx(styles.wrapper, className);

  return (
    <Badge
      variant={STATES[type].variant || "transparent"}
      type="strong"
      className={elementClass}
      startIcon={STATES[type].icon}
      iconOnly
    />
  );
};

export default HistoryEntryState;
